import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "63ee8c0e-b782-421c-8ca8-6b8698677fed", content: "Increased.", options: {} },
  { id: "634f0706-b9cb-439c-a7a0-84a1a82206fa", content: "Decreased.", options: {} },
  { id: "a7cf39dc-f9af-4d96-a7e9-8a0f6fad3876", content: "Same at all other frequencies.", options: {} },
  { id: "dd8c77d2-9db1-4e14-ad52-ff5812920fbb", content: "It can not be determined.", options: {} },
];

export const task: Task = {
  id: "3eaa9083-0b1e-45ef-8140-8dbcdd6903fc",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["634f0706-b9cb-439c-a7a0-84a1a82206fa"],
};
